export default "__VITE_ASSET__TSK3IN9o__"